module.exports = __webpack_public_path__ + "static/img/banner07.a9d1937.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner07.png
// module id = 9LJi
// module chunks = 1